export const REQUEST_WORK = "REQUEST_WORK";
export const RECEIVED_WORK = "RECEIVED_WORK";
export const ERROR_WORK = "ERROR_WORK";

export const WORK_NONE = "WORK_NONE";
export const WORK_REQUESTING = "WORK_REQUESTING";
export const WORK_RECEIVED = "WORK_RECEIVED";
export const WORK_ERROR = "WORK_ERROR";
